import { useCallback, useEffect, useState } from 'react';
import { AcceptTermsAPI, GetTermsAPI } from 'api';
import useStore from 'store/AccountStore';

function useTermsAcceptance({ enabled }) {
  const updateUser = useStore((state) => state.updateUser);
  const [termsContent, setTermsContent] = useState(null);
  const [isLoadingTerms, setIsLoadingTerms] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!enabled) {
      setTermsContent(null);
      setIsLoadingTerms(false);
      setErrorMessage('');
      return;
    }

    setIsLoadingTerms(true);
    setTermsContent(null);
    setErrorMessage('');

    GetTermsAPI({
      onSuccess: (data) => {
        setTermsContent(data);
      },
      onError: () => {
        setTermsContent(null);
      },
      callBack: () => {
        setIsLoadingTerms(false);
      },
    });
  }, [enabled]);

  const acceptTerms = useCallback(() => {
    setIsAccepting(true);
    setErrorMessage('');
    AcceptTermsAPI({
      onSuccess: () => {
        updateUser({ termsAccepted: true });
      },
      onError: () => {
        setErrorMessage(
          'Unable to save terms acceptance. Please try again.',
        );
      },
      callBack: () => {
        setIsAccepting(false);
      },
    });
  }, [updateUser]);

  return {
    termsContent,
    isLoadingTerms,
    isAccepting,
    errorMessage,
    acceptTerms,
  };
}

export default useTermsAcceptance;
